module.exports = __webpack_public_path__ + "img/1_021.f017cd4b.jpg";